import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// CSS
import "../../css/footer/social-media-nav.css";

const translationKey = "app";

class SocialNav extends React.PureComponent {
	render() {
		const { translationsLoading, translations } = this.props;

		return (
			<div className="social-media-nav">
				{!translationsLoading && (
					<span>{translations.sections[translationKey].social_media}:</span>
				)}
				<Link className="icon-facebook" to={`/`} title="Facebook" />
				<Link className="icon-twitter" to={`/`} title="Twitter" />
				<Link className="icon-linkedin" to={`/`} title="LinkedIn" />
				<Link className="icon-vimeo" to={`/`} title="Vimeo" />
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translationsLoading:
			state.translations.isLoading[translationKey] === undefined
				? 1
				: state.translations.isLoading[translationKey],
		translations: state.translations.translations
	};
};

export default connect(mapStateToProps)(SocialNav);



// WEBPACK FOOTER //
// ./src/components/footer/SocialNav.js